import React from 'react';

const AsyncBrandsContainer = React.lazy(() => import('./ListContainer'));

export const BrandsList = () => {
  return <AsyncBrandsContainer />;
};
